type Truncate = {
  text: string;
  length: number;
};

export default function truncate({ text, length = 18 }: Truncate) {
  return text.length > length ? text.substring(0, length - 3) + "..." : text;
}
